// import {message} from 'ant-design-vue'
import Home from './home.vue'

export default [{
    path: '/home',
    name:'home',
    component:Home
}]